import React from "react";

function escapeRegExp(s) {
  return s.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
}

// Wrap occurrences of the query's words in <mark> so the matched text stands
// out in a result title/snippet. Case-insensitive; returns an array of React
// nodes (plain strings + <mark> spans).
export default function highlightMatch(text, query) {
  const str = String(text || "");
  const terms = String(query || "")
    .trim()
    .split(/\s+/)
    .filter((t) => t.length >= 2);
  if (!str || !terms.length) return str;

  const re = new RegExp(`(${terms.map(escapeRegExp).join("|")})`, "ig");
  const lowerTerms = new Set(terms.map((t) => t.toLowerCase()));

  return str.split(re).map((part, i) =>
    lowerTerms.has(part.toLowerCase()) ? (
      <mark
        key={i}
        className="bg-[#F26322]/20 text-inherit rounded-[2px] px-[1px]"
      >
        {part}
      </mark>
    ) : (
      part
    )
  );
}
